import type { AttributeOption } from './landing'

// MP-OS-201: filter values follow the sales in the trend window. The API offers only values with
// sales in the curve's scope; a value that is already selected stays, marked, so a selection is
// never silently dropped. Both charts say the same thing when the selection sold nothing.
export const NO_SALES_FOR_SELECTION = 'No sales for this selection in the period.'
// MPD-133 Info: the ONE "no sales" wording for a value, article or series (filter option, its Reset,
// the article picker tag, the chart legend).
export const NO_SALES_IN_PERIOD = 'No sales in period'
export const NO_SALES_MARK = ` · ${NO_SALES_IN_PERIOD.toLowerCase()}`

export function optionText(option: AttributeOption, text: string): string {
  return option.no_sales ? `${text}${NO_SALES_MARK}` : text
}

/** The selected option of a facet when it has no sales in the period, else undefined. */
export function selectedWithoutSales(options: readonly AttributeOption[], value: string): AttributeOption | undefined {
  return value === 'All' ? undefined : options.find((o) => o.value === value && o.no_sales)
}

/** One key for the scope a matching_sold_cu answer was computed for, so a total from an earlier
 *  window, segment or selection is never applied to the charts on screen. */
export function salesScopeKey(scope: {
  manufacturer?: string | null; segment: string; from: string; to: string
  strength: string; fmt: string; category: string; flavour: string; nicotine: string; brands: readonly string[]
}): string {
  return JSON.stringify([scope.manufacturer ?? null, scope.segment, scope.from, scope.to, scope.strength, scope.fmt,
    scope.category, scope.flavour, scope.nicotine, [...scope.brands].map((b) => b.toLowerCase()).sort()])
}
